// extracted by mini-css-extract-plugin
module.exports = {"textTitle":"c6c5DVp","statsContainer":"c-kt2mV","rateContainer":"HCC0rG","rate":"A96l8n","total":"bhHjRv","ratingText":"fMGaak","stars":"Eo0BDe"};